import React, { useState } from "react";
import { Form, Formik } from "formik";
import AddressFormFields from "../../../../common/components/address-component/address-component";
import { Box, Paper, Button, Typography } from "@mui/material";
import "./lead-address-details-information-form.scss";
import { LeadData } from "./lead-details";
import { updateLeadDataById } from "../../../../api/provider-section/provider-service-management";
import { AlertComponent } from "../../../../common/components";
import * as Yup from "yup";
interface LeadAddressDetailsInformationFormProps {
  addressEdit: boolean;
  setAddressEdit: (value: boolean) => void;
  lead: LeadData;
  fetchLeadDetails: () => void;
}
const LeadAddressDetailsInformationForm: React.FC<
  LeadAddressDetailsInformationFormProps
> = ({ addressEdit, setAddressEdit, lead, fetchLeadDetails }) => {
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const leadAddressInitialValues = {
    streetLine1: lead.address?.street_line_1 || "",
    streetLine2: lead.address?.street_line_2 || "",
    city: lead.address?.city || "",
    state: lead.address?.state || "",
    zipcode: lead.address?.zipcode || "",
    country:
      lead.address?.country === "USA"
        ? "United States"
        : lead.address?.country || "",
  };
  const validationSchema = Yup.object({
    streetLine1: Yup.string().trim().optional(),
    city: Yup.string().trim().required("City is required"),
    state: Yup.string().trim().required("State is required"),
    zipcode: Yup.string().trim().required("Zipcode is required"),
    country: Yup.string().trim().required("Country is required"),
  });
  return (
    <>
      <Box className="lead-address-details-information-form">
        <Formik
          initialValues={leadAddressInitialValues}
          validationSchema={validationSchema}
          onSubmit={async (values, { resetForm }) => {
            try {
              // let interestedProductPayload = lead.needType;
              // if (lead.needType === "At-Need") {
              //   interestedProductPayload = "at_need";
              // } else if (lead.needType === "Pre-Need") {
              //   interestedProductPayload = "pre_need";
              // } else {
              //   interestedProductPayload = lead.needType;
              // }
              const response = await updateLeadDataById(lead.id, {
                id: lead.id,
                fullName: lead.name,
                primaryEmail: lead.email,
                primaryPhoneNumber: lead.phone,
                leadStatus: lead.leadStatus,
                // interestedProduct: interestedProductPayload,
                address: {
                  street_line_1: values.streetLine1,
                  street_line_2: values.streetLine2,
                  city: values.city,
                  state: values.state,
                  zipcode: values.zipcode,
                  country:
                    values.country === "United States"
                      ? "USA"
                      : values.country,
                },
              });
              setTimeout(() => setAddressEdit(false), 500);
              setAlertType("success");
              setAlertMessage(
                "Address updated successfully",
              );
              setAlertOpen(true);
              fetchLeadDetails();
            } catch (error: any) {
              console.error("Error updating lead address:", error);
              setAlertType("error");
              setAlertMessage("Failed to update lead address");
              setAlertOpen(true);
            }
          }}
          enableReinitialize
        >
          {({ resetForm, submitForm }) => (
            <Paper elevation={0} className="lead-address-details-form-section">
              <Box className="lead-address-details-section-header">
                <Typography
                  variant="h6"
                  className="lead-address-details-section-title"
                >
                  Address Information
                </Typography>
                <Box className="lead-address-details-section-actions">
                  <Button
                    variant="outlined"
                    className="lead-address-details-section-cancel-btn"
                    onClick={() => {
                      resetForm();
                      setAddressEdit(false);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => {
                      submitForm();
                    }}
                    className="lead-address-details-section-save-btn"
                  >
                    Save
                  </Button>
                </Box>
              </Box>
              <Form
                id="lead-address-details-form"
                className="lead-address-details-information-form__form"
              >
                <AddressFormFields
                  displayStreetLines={true}
                  displayCountry={true}
                  displayBusinessAddress={false}
                  postCode="zipcode"
                  requiredFields={{
                    city: true,
                    state: true,
                    zipcode: true,
                    address: true,
                    country: true,
                  }}
                  isProvider={true}
                  disabled={!addressEdit}
                />
              </Form>
            </Paper>
          )}
        </Formik>
      </Box>
      <AlertComponent
        open={alertOpen}
        type={alertType}
        message={alertMessage || ""}
        onClose={() => setAlertOpen(false)}
      />
    </>
  );
};
export default LeadAddressDetailsInformationForm;
